import { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';

import noAvatar from '@assets/img/noavatar.svg';
import { _ } from '@helpers';
import { analyzeImage } from '@helpers';
import { useAppSelector } from 'redux/store/store.types';
import { capitalize } from 'utils/common';

import { useAuthSession } from 'modules/auth-session';

import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { ExitToApp as ExitToAppIcon, Person as PersonIcon } from '@material-ui/icons';

import NibMenu from '@components/common/NibMenu/NibMenu';

import AdminToExchangeButton from './AdminToExchangeButton';
import NotificationButton from './NotificationButton';
import SideBar from './SideBar';
import css from './appNav.module.sass';

const AppNav = ({ isSideBarOpen, setSideBar }) => {
  const history = useHistory();
  const { logoutHandler } = useAuthSession();

  const { brandingSettings } = useAppSelector((state) => state.platform);
  const { currentUser } = useAppSelector((store) => store.authSession);

  const [menuOpen, setMenu] = useState(false);
  const [companyLogo, setCompanyLogo] = useState(null);
  const [bgColor, setBgColor] = useState('black');

  const openProfile = () => {
    setMenu(!menuOpen);
  };

  const signout = async () => {
    await logoutHandler();
  };

  const getAvatarSrc = () => {
    return currentUser && currentUser.avatar ? currentUser.avatar.url : noAvatar;
  };

  useEffect(() => {
    if (brandingSettings?.logo) {
      setCompanyLogo(brandingSettings.logo.url);
    }
  }, [brandingSettings]);

  const rolesDisabled = !!Number(process.env.REACT_APP_DISABLE_ROLES);
  const userRolesText = !rolesDisabled && <>{currentUser.roles.map((role) => capitalize(role.name)).join(', ')}</>;

  const handleMainSearchKeyDownEnter = (e) => {
    if (e.key === 'Enter') {
      alert('NO FUNCTION');
    }
  };

  if (!currentUser) return <></>;

  return (
    <>
      <SideBar open={isSideBarOpen} getAvatarSrc={getAvatarSrc} userRolesText={userRolesText} />
      <header className={css.header + ' appHeader bg-appDark70 max-w-screen-app px-5 app:px-0 inset-x-0 mx-auto'}>
        <div
          className={css.SideBarBurger + ' ' + (isSideBarOpen ? css.SideBarBurgerOpen : '')}
          onClick={() => {
            setSideBar(!isSideBarOpen);
            setTimeout(function () {
              window.dispatchEvent(new Event('resize'));
            }, 500);
          }}
        >
          <div className={css.SideBarBurgerImage}></div>
        </div>
        <div className={css.HeaderLogo} onClick={() => history.push('/')}>
          {companyLogo && <img className="!max-w-[140px]" src={companyLogo} alt="logo" />}
        </div>
        <div className="max-w-[695px] flex w-full ml-auto items-center gap-[10px]">
          <AdminToExchangeButton />
          <NotificationButton />
          <div className={css.HeaderSearchBlock + ' HeaderSearchBlock bg-appDark160'}>
            <div className={css.HeaderSearchInputBlock}>
              <div className={css.HeaderSearchIcon}></div>
              <input name="main_search" onKeyDown={handleMainSearchKeyDownEnter} placeholder="Search..." />
            </div>
            <div className={css.userProfile}>
              <div onClick={openProfile} className={css.userAvatar} style={{ backgroundColor: bgColor }}>
                <img
                  src={getAvatarSrc()}
                  alt="profile_logo"
                  crossOrigin="anonymous"
                  onLoad={(e) => {
                    const brightness = analyzeImage(e.target);
                    brightness !== null && setBgColor(brightness < 90 ? 'black' : '#D3D3D3');
                  }}
                />
                <NibMenu open={menuOpen}>
                  <List component="nav" aria-label="main mailbox folders">
                    <ListItem button onClick={() => history.push('/user-profile')}>
                      <ListItemIcon>
                        <PersonIcon style={{ color: '#fff' }} />
                      </ListItemIcon>
                      <ListItemText primary="Profile" />
                    </ListItem>
                    <ListItem button onClick={signout}>
                      <ListItemIcon>
                        <ExitToAppIcon style={{ color: '#fff' }} />
                      </ListItemIcon>
                      <ListItemText primary="Logout" />
                    </ListItem>
                  </List>
                </NibMenu>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default AppNav;
